import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Button, makeStyles, CircularProgress } from '@material-ui/core'

import {
  CLOSE,
  SECONDARY,
  WARNING,
  SUBMIT,
  INFO,
  CANCEL,
} from 'app/constants/button'

const useStyles = makeStyles((theme) => ({
  root: {
    textTransform: 'unset',
    padding: '0.75rem 1.25rem',
    border: '1px solid',
    borderRadius: '4px',
    // backgroundColor: 'transparent !important',
    '&.MuiButton-root.Mui-disabled': {
      opacity: '0.5 !important',
      color: '#00B2AD !important',
      borderColor: '#00B2AD !important',
      fontStyle: 'normal !important',
    },
  },
  close: {
    color: theme.colors['grey-200'],
    borderColor: theme.colors['grey-200'],
    backgroundColor: 'transparent !important',
    '&:hover': {
      color: theme.colors['grey-400'],
      borderColor: theme.colors['grey-400'],
    },
    '&:action': {
      color: theme.colors['grey-300'],
      borderColor: theme.colors['grey-300'],
    },
  },
  secondary: {
    color: theme.colors.secondary,
    borderColor: theme.colors.secondary,
    backgroundColor: 'transparent !important',
    '&:hover': {
      backgroundColor: `${theme.colors['secondary-light']} !important`,
    },
    '&:action': {
      backgroundColor: `${theme.colors['secondary-light']} !important`,
    },
  },
  warning: {
    color: theme.colors['orange-600'],
    borderColor: theme.colors['orange-300'],
    backgroundColor: theme.colors['orange-100'],
    '&:hover': {
      backgroundColor: `${theme.colors['orange-200']} !important`,
    },
    '&:action': {
      backgroundColor: `${theme.colors['orange-200']} !important`,
    },
  },
  submit: {
    color: theme.colors['primary'],
    borderColor: theme.colors['primary'],
    backgroundColor: 'transparent !important',
    '&:hover': {
      backgroundColor: `${theme.colors['primary-350']} !important`,
    },
    '&:action': {
      backgroundColor: `${theme.colors['primary-350']} !important`,
    },
  },
  info: {
    color: theme.colors['primary'],
    borderColor: theme.colors['primary-300'],
    backgroundColor: theme.colors['primary-200'],
    '&:hover': {
      backgroundColor: `${theme.colors['primary-200']} !important`,
    },
    '&:action': {
      backgroundColor: `${theme.colors['primary-200']} !important`,
    },
  },
  cancel: {
    color: theme.colors['red-500'],
    borderColor: theme.colors['red-500'],
    '&:hover': {
      backgroundColor: `${theme.colors['red-50']} !important`,
    },
    '&:action': {
      backgroundColor: `${theme.colors['red-50']} !important`,
    },
  },
}))

const OutlinedButtons = ({
  id,
  color,
  children,
  className,
  isLoading = false,
  disabled = false,
  ...rest
}) => {
  const classes = useStyles()

  const handleType = (color) => {
    switch (color) {
      case CLOSE:
        return classes.close
      case SECONDARY:
        return classes.secondary
      case WARNING:
        return classes.warning
      case SUBMIT:
        return classes.submit
      case INFO:
        return classes.info
      case CANCEL:
        return classes.cancel
      default:
        return
    }
  }

  return (
    <Button
      variant="outlined"
      className={clsx(classes.root, handleType(color), className)}
      disabled={disabled}
      data-testid={id}
      {...rest}
    >
      {isLoading ? (
        <CircularProgress size={24} style={{ color }} />
      ) : (
        <>{children}</>
      )}
    </Button>
  )
}

OutlinedButtons.propTypes = {
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
}
export default OutlinedButtons
